import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import NoSsr from '@glass/web/components/base/NoSsr';
import InlineCenterSkeleton from '@glass/web/components/Skeleton/InlineCenterSkeleton';

import ContentCard from '@glass/shared/components/Content/ContentCard';
import blogPostPropTypes from '@glass/shared/components/Content/propTypes/blogPostPropTypes';
import TagList from '@glass/shared/components/Content/TagList';
import generateBlogPostDate from '@glass/shared/modules/content/helpers/generateBlogPostDate';

function ResourceCard({
  imageSizes,
  variant,
  disableTags,
  loading,
  blogPost,
  onTagClick,
  onClick,
  className,
  bgcolor,
}) {
  const { updatedAt, title, color, size, publishedAt, slug, heroImage, tagsCollection } = blogPost;
  const { url, description } = heroImage || {};
  const { items: tags } = tagsCollection || {};

  const date = useMemo(
    () => generateBlogPostDate({ publishedAt, updatedAt }),
    [publishedAt, updatedAt],
  );

  return (
    <ContentCard
      bgcolor={bgcolor}
      className={className}
      color={color}
      image={url}
      imageSizes={imageSizes}
      imageTitle={description}
      loading={loading}
      size={size}
      slug={slug}
      subheader={<NoSsr fallback={<InlineCenterSkeleton inline width={130} />}>{date}</NoSsr>}
      title={title}
      variant={variant}
      onClick={onClick}
    >
      {!disableTags ? (
        <TagList leftPadding loading={loading} size="small" tags={tags} onTagClick={onTagClick} />
      ) : null}
    </ContentCard>
  );
}

ResourceCard.propTypes = {
  bgcolor: PropTypes.string,
  blogPost: blogPostPropTypes,
  className: PropTypes.string,
  disableTags: PropTypes.bool,
  imageSizes: PropTypes.string,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  onTagClick: PropTypes.func,
  variant: PropTypes.string,
};

ResourceCard.displayName = 'ResourceCard';

export default ResourceCard;
